var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"s-slice s-ribbon-inline",class:{ ..._vm.basicClassName }},[_c('div',{staticClass:"a-container"},[_c('div',{staticClass:"title"},[_vm._v("\n            "+_vm._s(_vm.title)+"\n        ")]),_vm._v(" "),_c('a-dangerous-html',{staticClass:"description",attrs:{"content":_vm.description}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }